<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M3 2v20"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-dasharray="4 40"
      stroke-dashoffset="-8"
      class="dart-audio-wave-bar-1" />
    <path
      d="M6 2v20"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-dasharray="10 40"
      stroke-dashoffset="-5"
      class="dart-audio-wave-bar-2" />
    <path
      d="M9 2v20"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-dasharray="6 40"
      stroke-dashoffset="-7"
      class="dart-audio-wave-bar-3" />
    <path
      d="M12 2v20"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-dasharray="16 40"
      stroke-dashoffset="-2"
      class="dart-audio-wave-bar-4" />
    <path
      d="M15 2v20"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-dasharray="6 40"
      stroke-dashoffset="-7"
      class="dart-audio-wave-bar-5" />
    <path
      d="M18 2v20"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-dasharray="10 40"
      stroke-dashoffset="-5"
      class="dart-audio-wave-bar-6" />
    <path
      d="M21 2v20"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-dasharray="4 40"
      stroke-dashoffset="-8"
      class="dart-audio-wave-bar-7" />
  </svg>
</template>

<style scoped>
@keyframes audio-wave-bar-1 {
  0%,
  100% {
    stroke-dasharray: 4 40;
    stroke-dashoffset: -8;
  }
  25% {
    stroke-dasharray: 9 40;
    stroke-dashoffset: -5.5;
  }
  50% {
    stroke-dasharray: 3 40;
    stroke-dashoffset: -8.5;
  }
  75% {
    stroke-dasharray: 7 40;
    stroke-dashoffset: -6.5;
  }
}

@keyframes audio-wave-bar-2 {
  0%,
  100% {
    stroke-dasharray: 10 40;
    stroke-dashoffset: -5;
  }
  25% {
    stroke-dasharray: 5 40;
    stroke-dashoffset: -7.5;
  }
  50% {
    stroke-dasharray: 14 40;
    stroke-dashoffset: -3;
  }
  75% {
    stroke-dasharray: 7 40;
    stroke-dashoffset: -6.5;
  }
}

@keyframes audio-wave-bar-3 {
  0%,
  100% {
    stroke-dasharray: 6 40;
    stroke-dashoffset: -7;
  }
  25% {
    stroke-dasharray: 15 40;
    stroke-dashoffset: -2.5;
  }
  50% {
    stroke-dasharray: 8 40;
    stroke-dashoffset: -6;
  }
  75% {
    stroke-dasharray: 12 40;
    stroke-dashoffset: -4;
  }
}

@keyframes audio-wave-bar-4 {
  0%,
  100% {
    stroke-dasharray: 16 40;
    stroke-dashoffset: -2;
  }
  25% {
    stroke-dasharray: 8 40;
    stroke-dashoffset: -6;
  }
  50% {
    stroke-dasharray: 18 40;
    stroke-dashoffset: -1;
  }
  75% {
    stroke-dasharray: 10 40;
    stroke-dashoffset: -5;
  }
}

@keyframes audio-wave-bar-5 {
  0%,
  100% {
    stroke-dasharray: 6 40;
    stroke-dashoffset: -7;
  }
  25% {
    stroke-dasharray: 12 40;
    stroke-dashoffset: -4;
  }
  50% {
    stroke-dasharray: 4 40;
    stroke-dashoffset: -8;
  }
  75% {
    stroke-dasharray: 14 40;
    stroke-dashoffset: -3;
  }
}

@keyframes audio-wave-bar-6 {
  0%,
  100% {
    stroke-dasharray: 10 40;
    stroke-dashoffset: -5;
  }
  25% {
    stroke-dasharray: 16 40;
    stroke-dashoffset: -2;
  }
  50% {
    stroke-dasharray: 6 40;
    stroke-dashoffset: -7;
  }
  75% {
    stroke-dasharray: 12 40;
    stroke-dashoffset: -4;
  }
}

@keyframes audio-wave-bar-7 {
  0%,
  100% {
    stroke-dasharray: 4 40;
    stroke-dashoffset: -8;
  }
  25% {
    stroke-dasharray: 7 40;
    stroke-dashoffset: -6.5;
  }
  50% {
    stroke-dasharray: 3 40;
    stroke-dashoffset: -8.5;
  }
  75% {
    stroke-dasharray: 10 40;
    stroke-dashoffset: -5;
  }
}

.group\/animate-audio:hover .dart-audio-wave-bar-1 {
  animation: audio-wave-bar-1 1.1s ease-in-out infinite;
}

.group\/animate-audio:hover .dart-audio-wave-bar-2 {
  animation: audio-wave-bar-2 1.4s ease-in-out infinite;
}

.group\/animate-audio:hover .dart-audio-wave-bar-3 {
  animation: audio-wave-bar-3 1.25s ease-in-out infinite;
}

.group\/animate-audio:hover .dart-audio-wave-bar-4 {
  animation: audio-wave-bar-4 1.55s ease-in-out infinite;
}

.group\/animate-audio:hover .dart-audio-wave-bar-5 {
  animation: audio-wave-bar-5 1.2s ease-in-out infinite;
}

.group\/animate-audio:hover .dart-audio-wave-bar-6 {
  animation: audio-wave-bar-6 1.45s ease-in-out infinite;
}

.group\/animate-audio:hover .dart-audio-wave-bar-7 {
  animation: audio-wave-bar-7 1.05s ease-in-out infinite;
}
</style>
